module.exports = __webpack_public_path__ + "static/media/RP-55.2ead514a.pdf";